<mat-menu #moreMenu>
  <button
    *ngIf="checkout?.renewable && !checkout?.renewed"
    [class.waiting]="waiting"
    mat-menu-item
    (click)="doRenew()"
  >
    <ng-container *ngIf="!waiting">
      <opac-icon [ariaHidden]="true" class="icon" icon="refresh_30"></opac-icon>
      <span>{{ 'button.renew' | translate }}</span>
    </ng-container>

    <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
  </button>

  <button
    *ngIf="showReturnLoanButton && isCheckedOut && checkout && checkout?.returnable"
    [class.waiting]="waiting"
    mat-menu-item
    (click)="doReturn()"
  >
    <ng-container *ngIf="!waiting">
      <opac-icon [ariaHidden]="true" class="icon" icon="loan"></opac-icon>
      <span>{{ 'button.return' | translate }}</span>
    </ng-container>

    <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
  </button>

  <button
    [id]="'favoriteButton' + record?.id"
    mat-menu-item
    (click)="toggleFavorite()"
  >
    <opac-icon [ariaHidden]="true" class="icon" [icon]="favoriteIcon"></opac-icon>
    <span>{{ favoriteText | translate }}</span>
  </button>

  <button *ngIf="showShareButtons" mat-menu-item [matMenuTriggerFor]="shareMenu">
    <opac-icon [ariaHidden]="true" class="icon" icon="share"></opac-icon>
    <span>{{ 'general.share' | translate }}</span>
    <opac-icon [ariaHidden]="true" class="caret-icon" icon="navigate_next"></opac-icon>
  </button>

  <mat-menu #shareMenu>
    <app-share-menu
      [include]="socialButtons"
      [description]="shareText"
      [title]="record.title"
      [url]="getSharingUrl(record.id)"
    ></app-share-menu>
  </mat-menu>

  <button mat-menu-item [matMenuTriggerFor]="listsMenu">
    <opac-icon [ariaHidden]="true" class="icon" icon="list_notebook"></opac-icon>
    <span>{{ 'tooltip.addToList' | translate }}</span>
    <opac-icon [ariaHidden]="true" class="caret-icon" icon="navigate_next"></opac-icon>
  </button>

  <mat-menu #listsMenu>
    <button mat-menu-item (click)="openNewListDialog()">
      <opac-icon [ariaHidden]="true" class="icon" icon="add"></opac-icon>
      <span>{{ 'button.newList' | translate }}</span>
    </button>

    <mat-divider *ngIf="userService.lists.length"></mat-divider>

    <button *ngFor="let list of userService.lists" mat-menu-item (click)="addToList(list.id)">
      <span ellipsis>{{ list.name }}</span>
      <opac-icon *ngIf="isRecordInList(list.id, record.id)" [ariaHidden]="true" class="added-list-icon" icon="check"></opac-icon>
    </button>
  </mat-menu>

  <button *ngIf="record.citable" mat-menu-item (click)="openCitationDialog()">
    <opac-icon [ariaHidden]="true" class="icon" icon="quotes"></opac-icon>
    <span>{{ 'tooltip.cite' | translate }}</span>
  </button>

  <button *ngIf="showReportIssueButton" mat-menu-item (click)="openReportDialog()">
    <opac-icon [ariaHidden]="true" class="icon" icon="report_problem"></opac-icon>
    <span>{{ 'report.title' | translate }}</span>
  </button>

</mat-menu>

<opac-button [matMenuTriggerFor]="moreMenu" appStopPropagation>
  <opac-icon [ariaHidden]="true" icon="more_vertical" slot="only-icon"></opac-icon>
</opac-button>
